
require("pixi-particles");

import {AnimatedParticle, Emitter, OldEmitterConfig} from "pixi-particles";
import { TimeCheckPoints } from "../../../dev/utils/TimeCheckPoints";
import { gsap } from 'gsap';


export class ParticleController {
    
    private _emitter:Emitter;
    private _timeName:string = "Particles";

    private deltaTime:number = 0;
    
    private get elapsedTime():number { return TimeCheckPoints.getCheckPointTime(this.timeName); }
    
    private get timeName():string { return this._timeName; }

    private set timeName(name:string){
        this._timeName = name;
        TimeCheckPoints.setCheckPoint(name);
    }

    public get inGame():boolean{
        return !!this._emitter.parent;
    }

    public set visible(value:boolean){
        if(!value) this._emitter.cleanup();
    }
    
    constructor(layer:PIXI.Container, type:string = "Particles", partTexture:PIXI.Texture[], config:OldEmitterConfig,loops?:boolean ){
        this.timeName = type;
        this._emitter = new Emitter(layer, [{
            framerate : 30,
            loop : !!loops,
            hasLoaded : true,
            textures : partTexture
        }], config);
        this._emitter.particleConstructor = AnimatedParticle;
        this._emitter.emit = false;
    }

    public update():void {
        this._emitter.update((this.elapsedTime - this.deltaTime)* 0.001)
        this.deltaTime = this.elapsedTime;
    }

    public enableEmit(value:boolean):void {
        this._emitter.emit = value;
    }

    public setPos(newPos:PIXI.Point):void{
        this._emitter.spawnPos.copyFrom(newPos);
    }

    public moveFromTo(from:PIXI.Point,to:PIXI.Point, duration:number):void{
        this._emitter.spawnPos.copyFrom(from);

        const tl:gsap.core.Timeline = new gsap.core.Timeline({
            onUpdate:() => { 
                this._emitter.spawnPos.copyFrom(from);
            }
        });
        tl.to(from,{y:to.y,duration:duration});
    }

    public remove():void{
        this.visible = false;
        this._emitter.destroy();
        TimeCheckPoints.removeCheckPoint(this.timeName);
    }
}